const NiemEventCodes = {
    "MA96": "OCR-B FIELD MISSING(BLANK)",
    "AA": "BASE FEE ADJUSTMENT MADE",
    "AAO": "ATTORNEY ATTACHED",
    "AAB": "RECEIVED - FINGERPRINT FEE",
    "AAC": "BASE FEE ADJUSTMENT MADE",
    "AALB": "RECEIVED AT THE LOCKBOX",
    "ABA": "RECEIVED, FEE WAIVED",
    "ABB": "RECEIVED - FEE COLLECTED ELSEWHERE",
    "ACA": "RECEIVED, FEE IN SUSPENSE",
    "ACB": "FEE SUSPENSE ACTION - DETERMINED THAT FEE REQUIRED",
    "ACC": "FEE SUSPENSE REMOVED - REJECTED SINCE FEE NOT PAID",
    "ADA": "FEE SUSPENSE REMOVED - FEE ACCEPTED",
    "ADB": "FEE SUSPENSE REMOVED - FEE WAIVED",
    "ADC": "FEE SUSPENSE REMOVED - NO FEE REQUIRED",
    "AE": "CASE RESUBMITTED",
    "AF": "REJECTED",
    "AFAA": "REJECTED/CHECK/MO NOT SIGNED",
    "AFAB": "REJECTED/APPLICATION/PETITION NOT SIGNED",
    "AFAC": "REJECTED/INCORRECT OR NO FEE",
    "AFAD": "REJECTED/NOT CURRENT VERSION OF FORM",
    "AFAE": "REJECTED/CASE IMPROPERLY APPEALED",
    "AFAI": "REJECT/FORM NOT SIGNED/INCORRECT FEE",
    "AFBA": "REJECTED/CHECK/MO & APPLICATION/PETITION NOT SIGNED",
    "AFBB": "REJECTED/CHECK/MO NOT SIGNED AND INCORRECT OR NO FEE",
    "AFBC": "REJECTED/CHECK/MO NOT SIGNED & NOT CURRENT VERSION OF FORM",
    "AFBD": "REJECTED/CHECK/MO NOT SIGNED & CASE IMPROPERLY APPEALED",
    "AFBE": "REJECTED/APPLICATION/PETITION NOT SIGNED AND INCORRECT OR NO FEE",
    "AFBF": "REJECTED/APP/PET NOT SIGNED & NOT CURRENT VERSION OF FORM",
    "AFBG": "REJECTED/APPLICATION/PETITION NOT SIGNED & CASE IMPROPERLY APPEAL",
    "AFBH": "REJECTED/INCORRECT OR NO FEE & NOT CURRENT VERSION OF FORM",
    "AFBI": "REJECTED/INCORRECT OR NO FEE & CASE IMPROPERLY APPEALED",
    "AFBJ": "REJECTED/NOT CURRENT VERSION OF FORM & CASE IMPROPERLY APPEALED",
    "AFCA": "REJECTED/CHECK/MO & APP/PET NOT SIGNED AND INCORRECT OR NO FEE",
    "AFCB": "REJECTED/CHECK/MO & APP/PET NOT SIGNED & NOT CURRENT FORM",
    "AFCC": "REJECTED/CHECK/MO & APP/PET NOT SIGNED & CASE IMPROPERLY APPEALED",
    "AFCD": "REJECTED/CHECK/MO NOT SIGNED, INCORRECT FEE, NOT CURRENT FORM",
    "AFCE": "REJECTED/CHECK/MO NOT SIGNED, INCORRECT FEE, IMPROPER APPEAL",
    "AFCF": "REJECTED/CHECK/MO NOT SIGNED, NOT CURRENT FORM, IMPROPER APPEAL",
    "AFCG": "REJECTED/APP/PET NOT SIGNED, INCORRECT FEE, NOT CURRENT FORM",
    "AFCH": "REJECTED/APP/PET NOT SIGNED, INCORRECT FEE, IMPROPER APPEAL",
    "AFCI": "REJECTED/APP/PET NOT SIGNED, NOT CURRENT FORM, IMPROPER APPEAL",
    "AFCJ": "REJECTED/INCORRECT FEE, NOT CURRENT FORM, IMPROPER APPEAL",
    "AFDA": "REJECTED/CHECK/MO & APP/PET NOT SIGNED, INCORR FEE, NOT CURR FORM",
    "AFDB": "REJECTED/CHECK/MO & APP/PET NOT SIGNED, INCORR FEE, IMPROP APPEAL",
    "AFDC": "REJECTED/CHECK/MO & APP/PET NOT SIGNED, NOT CURR FORM, IMPROP APP",
    "AFDD": "REJECTED/CHECK/MO NOT SIGNED, NO FEE, NOT CURR FORM, IMPROP APP",
    "AFDE": "REJECTED/APP/PET NOT SIGNED, NO FEE, NOT CURR FORM, IMPROP APPEAL",
    "AFEA": "REJECTED/NOTHING SIGNED, INCORRECT FEE, NOT CURR FORM, IMPROP APP",
    "AFFA": "REJECTED/FILED TOO EARLY",
    "AFZZ": "REJECTED/OTHER",
    "AGA": "REOPENED OR RECONSIDERED ON SERVICE MOTION WITHOUT APPEAL",
    "AGB": "REOPENED/RECONSIDERED ON USCIS MOTION BASED ON APPEAL",
    "AH": "REOPENED BY COURT REMAND",
    "AI": "TERMINATED CASE REOPENED",
    "AJA": "CHECK BOUNCED, CASE NOT YET COMPLETED",
    "AJB": "CHECK BOUNCED, CASE ALREADY APPROVED",
    "AJC": "CHECK BOUNCED, CASE ALREADY DENIED, REVOKED, OR ABANDONED",
    "AKA": "BOUNCED CHECK CORRECTED ON CASE NOT YET COMPLETED",
    "AKB": "BOUNCED CHECK CORRECTED ON CASE ALREADY APPROVED",
    "AKC": "BOUNCED CHECK CORRECTED ON CASE ALREADY DENIED",
    "ALA": "BOUNCED CHECK NOT CORRECTED, REJECTED",
    "ALB": "BOUNCED CHECK NOT CORRECTED, REVOKED",
    "ALC": "BOUNCED CHECK NOT CORRECTED ON PREVIOUS DENIAL",
    "ALD": "BOUNCED CHECK CORRECTION DEFICIENT",
    "AMA": "CREDIT CARD VERIFICATION SUSPENSE",
    "AMB": "CREDIT CARD PAYMENT APPROVED",
    "AMC": "CREDIT CARD PAYMENT REJECTED",
    "AMD": "CREDIT CARD VERIFICATION UNSUCCESSFUL",
    "ANA": "FEE REFUNDED",
    "ANB": "FEE REFUND SENT",
    "ANC": "FEE SURCHARGE REFUNDED",
    "AOA": "FPF DEFICIENCY - INCORRECT AMOUNT",
    "AOB": "FPF DEFICIENCY - REMITTANCE NOT SIGNED",
    "AOC": "FPF DEFICIENCY - REMITTANCE NOT SIGNED AND INCORRECT AMOUNT",
    "BA": "RELOCATED FOR PROCESSING",
    "BAA": "REMOTED FOR PROCESSING",
    "BB": "RELOCATED TO NEW JURISDICTION",
    "BC": "RELOCATED FROM SC TO LOCAL OFFICE FOR STANDARD INTERVIEW",
    "BD": "RELOCATED FROM SC FOR FIELD REVIEW OR INVESTIGATION",
    "BE": "APPEAL/MOTION/CERTIFICATION SENT TO AAO",
    "BF": "APPEAL/MOTION/CERTIFICATION SENT TO EOIR",
    "BG": "RELOCATED TO ORIGINATING OFFICE BY AAO",
    "BH": "RELOCATED TO ORIGINATING OFFICE BY EOIR",
    "BI": "RELOCATED TO ORIGINATION OFFICE BY DOS FOR REVIEW",
    "BJ": "RELOCATE TO ASYLUM OFFICE",
    "BK": "RELOCATED TO MFAS",
    "BK0": "MOTION TO APPELLATE BODY",
    "BL1": "PHYSICAL CASE FILE RELOCATED FROM NBC TO FIELD OFFICE",
    "BL2": "ELECTRONIC FILE RELOCATED FROM ASC TO NBC",
    "BL3": "ELECTRONIC FILE RELOCATED FROM ASC TO FIELD OFFICE",
    "CA": "RELOCATED RECEIVED FROM OTHER INS CENTER OR OFFICE",
    "Card": "Undeliverable",
    "CB": "RELOCATED RECEIVED FROM AAO",
    "CC": "RELOCATED RECEIVED FROM EOIR",
    "CD": "CASE RELOCATED RECEIVED FROM STATE DEPARTMENT FOR REVIEW",
    "DA": "APPROVED/NOTICE ORDERED",
    "DAEA": "SPLIT DECISION/NOTICE ORDERED",
    "DB": "APPROVED & CERTIFIED/NOTICE ORDERED",
    "DC": "APPROVED IN PART/NOTICE ORDERED",
    "DD": "APPROVED IN PART & CERTIFIED/NOTICE ORDERED",
    "DE": "CASE ORDERED APPROVED BY AAO/NOTICE ORDERED",
    "DF": "CASE ORDERED APPROVED BY EOIR/NOTICE ORDERED",
    "DG": "CASE ORDERED APPROVED BY COURT/NOTICE ORDERED",
    "DH": "APPROVED ON SERVICE MOTION/NOTICE ORDERED",
    "DI": "APPROVAL REAFFIRMED AFTER DOS RETURN/NOTICE ORDERED",
    "DJ": "VISA ISSUED BY DOS",
    "EA": "DENIAL NOTICE ORDERED",
    "EA0": "LOCAL OFFICE FINAL DECISION",
    "EAA": "DENY FOR SOME - ORDER NOTICE",
    "EB": "DENIAL & CERTIFICATION NOTICE ORDERED",
    "EBA": "DENY FOR SOME AND CERTIFY - ORDER NOTICE",
    "EC": "DENIAL NOTICE WITH FINDING OF FRAUD ORDERED",
    "ED": "DENIAL & CERTIFICATION NOTICE WITH FINDING OF FRAUD ORDERED",
    "EE": "CASE ORDERED DENIED BY AAO",
    "EF": "CASE ORDERED DENIED BY EOIR",
    "EGA": "REVOCATION NOTICE ORDERED",
    "EGB": "REVOCATION NOTICE WITH FINDING OF FRAUD ORDERED",
    "EGC": "REVOCATION & CERTIFICATION NOTICE ORDERED",
    "EGD": "REVOCATION & CERTIFICATION NOTICE W/FINDING OF FRAUD ORDERED",
    "EH0": "RESCISSION",
    "EHA": "RESCISSION NOTICE ORDERED",
    "EHA0": "RESCISSION FILED",
    "EHB": "RESCISSION NOTICE WITH FINDING OF FRAUD ORDERED",
    "EHC": "RESCISSION & CERTIFICATION NOTICE ORDERED",
    "EHD": "RESCISSION & CERTIFICATION W/FINDING OF FRAUD ORDERED",
    "EI": "DENIAL OF MOTION NOTICE ORDERED",
    "EJ": "MOTION GRANTED - DENIAL OF RENEWED CASE NOTICE ORDERED",
    "EK": "WITHDRAWAL ACKNOWLEDGMENT NOTICE ORDERED",
    "EL": "ABANDONMENT DENIAL NOTICE ORDERED",
    "EM": "AUTOMATIC TERMINATION PER OI 103.2(o) NOTICE ORDERED",
    "EN": "CASE TERMINATED; STATUS ACQUIRED THROUGH OTHER MEANS",
    "EO": "VISA DENIED BY DOS",
    "EP": "PETITION TERMINATED BY DOS",
    "EQ": "PETITION REVOKED BY DOS",
    "ER": "SERVICE DENIAL UPHELD BY COURT",
    "ERA0": "COURT APPEAL FILED",
    "ERB0": "SVC DIRECTED LET PREVIOUS APPVL STAND",
    "ES0": "DENY OTHER",
    "EW0": "AUTOMATICALLY REVOKE",
    "EX": "SYSTEM CLOSURE",
    "EX0": "APPEAL WITHDRAWN - ADMINISTRATIVE",
    "EY2": "PHASE I DECISION CHANGED TO T",
    "EZ": "ADMINISTRATIVE CLOSE",
    "FA": "CASE RETURN FOR ADDITIONAL EVIDENCE NOTICE ORDERED",
    "FAA": "LITIGATION CASE LOADED",
    "FAB": "CIS ADD CONFIRMED",
    "FB0": "REQUEST EVIDENCE",
    "FBA": "INITIAL EVIDENCE REQUEST NOTICE ORDERED",
    "FBB": "ADDITIONAL EVIDENCE REQUEST NOTICE ORDERED",
    "FBC": "INITIAL AND ADDITIONAL EVIDENCE REQUESTED NOTICE ORDERED",
    "FC": "INTENT TO REVOKE NOTICE ORDERED",
    "FCA0": "INTENT TO REVOKE - FRAUD",
    "FCB0": "INTENT TO REVOKE - OTHER",
    "FD": "INTENT TO RESCIND NOTICE ORDERED",
    "FE": "INTENT TO DENY NOTICE ORDERED",
    "FF0": "SENT TO BENEFIT FRAUD UNIT (BFU)",
    "FF1": "SENT TO FRAUD DETECTION UNIT (FDU) FOR ANALYSIS",
    "FF2": "SENT TO NATIONAL SECURITY ADJUDICATIONS UNIT FOR ANALYSIS",
    "FFA": "OVERSEAS INVESTIGATION REQUESTED",
    "FFB": "DOMESTIC INVESTIGATION REQUESTED",
    "FG": "NON-USCIS ADVISORY OPINION REQUESTED",
    "FG0": "FORWARDED FOR SERVICE BRIEF",
    "FH": "PLACE IN INTERVIEW QUE",
    "FHA": "SCHEDULE CASE FOR ASYLUM INTERVIEW",
    "FHB": "READY FOR INTERVIEW SCHEDULING",
    "FI": "FORCE SCHEDULE INTERVIEW",
    "FJ": "INTERVIEW SCHEDULED/NOTICE ORDERED",
    "FKA": "DESCHEDULE",
    "FKB": "CANCEL INTERVIEW BASED ON REQUEST",
    "FL": "FAILED TO APPEAR FOR INTERVIEW OR ADIT PROCESSING",
    "FLR": "RETURN FROM LAW ENFORCEMENT SUPPORT CENTER",
    "FLS": "SENT TO LAW ENFORCEMENT SUPPORT CENTER",
    "FM": "RESCHEDULE INTERVIEW",
    "FN": "FINGERPRINT/AGENCY CHECKS ORDERED",
    "FNA": "FINGERPRINT APPOINTMENT NOTICE ORDERED",
    "FNB": "FINGERPRINTS TAKEN",
    "FNC": "FD-258 SENT TO FBI",
    "FND": "FD-258 REJECTED BY FBI-IMMEDIATE REJECT",
    "FNE": "FD-258 REJECTED BY FBI-UNCLASSIFIABLE",
    "FNF": "FD-258 RESENT TO FBI",
    "FNG": "FINGERPRINT PROCESSING COMPLETE-IDENT",
    "FNH": "FINGERPRINT PROCESSING COMPLETE-NON-IDENT",
    "FNI": "FBISCHED FINGERPRINT STATUS ADJUSTED",
    "FO0": "REQUEST FILE",
    "FOA": "FILE TRANSFER REQUEST ORDERED - PROCESSING NOT SUSPENDED",
    "FOB": "FILE TRANSFER REQUEST ORDERED - PROCESSING SUSPENDED",
    "FP": "ADIT PROCESSING REQUESTED AFTER APPROVAL",
    "FQ": "REQUEST ADIT RE-PROCESSING/NOTICE ORDERED",
    "FQA": "REQUEST FOR NOTICE ORDERED",
    "FQB": "NOTICE TO APPEAR ORDERED",
    "FR": "ADJUDICATION HOLD LIFTED",
    "FS": "ADJUDICATION HOLD PLACED",
    "FSA0": "REQUEST DATABASE CHECKS",
    "FT": "PROCESSING HOLD LIFTED",
    "FT0": "OFFICER PROCESSING BEGUN",
    "FTA0": "DATABASE CHECKS RECEIVED",
    "FU": "ELIGIBLE TO FILE SUPPLEMENTAL WAIVER OR APP.; NOTICE ORDERED",
    "FV": "CONTINUED FOR CIVICS AND/OR ENGLISH RETEST; CASE ON HOLD",
    "FWA": "TERMINATE ACTION TO REVOKE",
    "FWB": "TERMINATE ACTION TO RESCIND",
    "FX0": "EXTENSION FOR BRIEF GRANTED",
    "FXA": "TERMINATE PLACEMENT IN INTERVIEW QUE",
    "FXX0": "EXTENSION FOR BRIEF DENIED",
    "FY0": "TREAT AS MOTION",
    "FYD": "LEGALIZATION PHASE 1 L.O. RECOMMENDATION OF DENIAL",
    "FYG": "LEGALIZATION PHASE 1 L.O. RECOMMENDATION OF GRANT",
    "FZA": "T-1 WAITING LIST",
    "FZB": "BONA FIDE DEFERRED ACTION",
    "FZC": "BONA FIDE IN REMOVAL",
    "HA": "RESPONSE TO REQUEST NOTICE TO APPLICATION/PETITION RECEIVED",
    "HA0": "WAIVER REQUEST",
    "HA1": "IMBRA WAIVER APPROVAL",
    "HA2": "IMBRA WAIVER DENIAL",
    "HAP": "RESET PREMIUM PROC. CLOCK - EVIDENCE RECEIVED",
    "HB": "NOTICE RETURNED AS UNDELIVERABLE",
    "HC": "INVESTIGATIVE REPORT/AGENCY CHECKS RECEIVED",
    "HCB0": "RET FROM FRAUD UNIT NORMAL PROCESS",
    "HCC0": "RETURN FROM BENEFIT FRAUD UNIT (BFU) WITH RESULTS",
    "HCC1": "RETURN FROM FRAUD DETECTION UNIT (FDU) WITH RESULTS",
    "HD": "CORRESPONDENCE RECEIVED",
    "HE": "REQUEST TO RE-SCHEDULE INTERVIEW RECEIVED",
    "HF": "ADIT PROCESSING COMPLETED",
    "HG": "INTERVIEW CONDUCTED",
    "HH": "INVESTIGATION OR FIELD REVIEW NOT ACCEPTED",
    "HI": "I-89 RECEIVED",
    "HJ0": "FILE RECEIVED",
    "HK0": "CONFIRMED DAU RESULTS RECEIVED",
    "IA0": "PROYESTO SAN PABLO/ INS NOTE SENT",
    "IAA": "RECEIPT NOTICE SENT",
    "IAAA": "RECEIPT NOTICE W/REQUEST FOR I-89 PROCESSING SENT",
    "IAB": "MODIFIED RECEIPT NOTICE 1 SENT",
    "IAC": "MODIFIED RECEIPT NOTICE 2 SENT",
    "IAD": "FEE COLLECTED ELSEWHERE RECEIPT NOTICE SENT",
    "IAE": "FINGERPRINT FEE RECEIPT NOTICE SENT",
    "IAF": "RECEIPT LETTER EMAILED",
    "IBA": "FEE SUSPENSE RECEIPT NOTICE SENT",
    "IBB": "FEE SUSPENSE - FEE NOW REQUIRED NOTICE SENT",
    "IBC": "FEE SUSPENSE REJECTION NOTICE SENT",
    "IBD": "FEE SUSPENSE REMOVAL NOTICE SENT",
    "IBE": "FINGERPRINT BILLING NOTICE SENT",
    "IBS1": "NO SYSTEM IDENTIFIED DEROGATORY INFORMATION",
    "IBS2": "IBS2: Pending",
    "IBS3": "IBS3: DNR (Does Not Relate)",
    "IBS4": "IBS4: Resolved",
    "IC": "REJECTION NOTICE SENT",
    "ICA": "FINGERPRINT FEE DEFICIENCY NOTICE SENT",
    "ID": "RESUBMISSION ACKNOWLEDGMENT NOTICE SENT",
    "IEA": "APPROVAL NOTICE SENT",
    "IEB": "CERTIFICATION APPROVAL NOTICE SENT",
    "IEC": "WELCOME NOTICE SENT",
    "IEE": "APPROVAL LETTER EMAILED",
    "IFA": "DENIAL NOTICE SENT",
    "IFAA": "ABANDONMENT DENIAL NOTICE SENT, INCORRECT FP FEE",
    "IFAB": "ABANDONMENT DENIAL NOTICE SENT, FAILURE TO APPEAR FOR FP",
    "IFAC": "ABANDONMENT DENIAL NOTICE SENT, FP APPEAR. REQUESTS UNDELIVERABLE",
    "IFAD": "ABANDONMENT DENIAL NOTICE SENT, FINGERPRINT FEE NOT RECEIVED",
    "IFAE": "ABANDONMENT DENIAL NOTICE SENT, SUBJ. ABROAD NOT SUBMITTED FP",
    "IFAF": "ABANDONMENT DENIAL NOTICE SENT, SUBJ. NOT SUPPL. DEFICIENCY DATA",
    "IFB": "CERTIFICATION DENIAL NOTICE SENT",
    "IG": "DUPLICATE NOTICE SENT",
    "IH": "AMENDED NOTICE SENT",
    "II": "NOTICE OF INTENT TO DENY SENT",
    "IJ": "INDEPENDENT CABLE SENT OR POE TELEPHONED",
    "IK": "REQUEST FOR ADDITIONAL EVIDENCE SENT",
    "IKE": "INITIAL EVIDENCE REQUESTED VIA E-FILING SYSTEM",
    "IKF": "INITIAL EVIDENCE REMINDER EMAILED",
    "IKP": "STOP PREMIUM PROC. CLOCK - REQUEST FOR EVIDENCE SENT",
    "IL": "RETURN NOTICE + CASE SENT",
    "IM": "INTERVIEW NOTICE SENT",
    "IMAF": "FINGERPRINT APPOINTMENT NOTICE SENT",
    "IN": "ADIT NOTICE SENT",
    "IO": "REOPENING NOTICE SENT",
    "IP": "TRANSFER NOTICE SENT",
    "IQ": "AFFIRMATION NOTICE",
    "IQB": "BONA FIDE DEFERRED ACTION NOTICE SENT",
    "IQC": "BONA FIDE IN REMOVAL NOTICE SENT",
    "IR": "REVOCATION NOTICE SENT",
    "IS": "RESCISSION NOTICE SENT",
    "IT": "WITHDRAWAL ACKNOWLEDGMENT NOTICE SENT",
    "IU": "NOTICE OF INTENT TO RESCIND SENT",
    "IV": "NOTICE OF INTENT TO REVOKE SENT",
    "IWA": "CHECK DEFICIENCY NOTICE 1 SENT",
    "IWB": "CHECK DEFICIENCY NOTICE 2 SENT",
    "IWC": "CHECK DEFICIENCY NOTICE 3 SENT",
    "IWD": "CHECK DEFICIENCY REJECTION NOTICE SENT",
    "IWE": "CHECK DEFICIENCY REVOCATION NOTICE SENT",
    "IWF": "CHECK DEFICIENCY ON DENIAL NOTICE SENT",
    "IWG": "BOUNCED CHECK CORRECTION NOT ACCEPTED NOTICE SENT",
    "IXAA": "INTERVIEW CANCELLATION BY INS - NOTICE SENT",
    "IXAB": "INTERVIEW CANCELLATION PER REQUEST - NOTICE SENT",
    "IXB": "CONTINUATION NOTICE SENT",
    "IXC": "NOTICE TO APPEAR SENT",
    "IYA": "INTENT TO TERMINATE STATUS NOTICE SENT",
    "IYB": "STATUS TERMINATION NOTICE SENT",
    "IYC": "STATUS TERMINATION CERTIFICATION NOTICE SENT",
    "IZ": "LITIGATION NOTICE SENT",
    "IZB": "LITIGATION TERMINATE MAILER SENT",
    "IZZ": "FY05 OMNIBUS SPENDING BILL CAP EXEMPTION",
    "JA": "ELIGIBILITY NOTICE SENT",
    "JB": "FEE REFUND INVITATION SENT",
    "JC": "FAX REPLY SENT",
    "JCA": "CUSTOMER INQUIRY RESPONSE SENT",
    "JZ": "NOTICE GENERATED",
    "JZA": "I-90 ATTORNEY NOTICE SENT",
    "KA": "SUPERVISORY HOLD PLACED",
    "KAA": "SUPERVISORY HOLD/NO INSPECTOR STAMP",
    "KAB": "SUPERVISORY HOLD/NO INSPECTOR SIGNATURE",
    "KAC": "SUPERVISORY HOLD/NO APPLICANT SIGNATURE",
    "KAD": "SUPERVISORY HOLD/I89 NOT ATTACHED",
    "KAE": "SUPERVISORY HOLD/MISSING BIOMETRIC DATA",
    "KAF": "SUPERVISORY HOLD/MISSING BIOGRAPHIC DATA",
    "KAG": "SUPERVISORY HOLD/NO ADJUDICATOR STAMP",
    "KB0": "HOLD OTHERWISE REMOVED",
    "KBA": "SUPERVISORY HOLD CLEARED - ACTION CONFIRMED",
    "KBB": "SUPERVISORY HOLD CLEARED - ACTION CANCELLED",
    "KBC": "ADD. REQ APPROVED BY LEVEL 1, CASE HOLD AWAITING LEVEL 2 APPROVAL",
    "KBD": "ADD. CARD REQUEST NOT APPROVED BY LEVEL 1 SUPV, ACTION CANCELLED",
    "KBE": "ADD. CARD REQUEST APPROVED BY LEVEL 2 SUPV, ACTION CONFIRMED",
    "KBF": "ADD. CARD REQUEST NOT APPROVED BY LEVEL 2 SUPV, ACTION CANCELLED",
    "KC": "QUALITY REVIEW HOLD PLACED",
    "KDA": "QUALITY REVIEW HOLD CLEARED - ACTION CONFIRMED",
    "KDB": "QUALITY REVIEW HOLD CLEARED - ACTION CANCELLED",
    "KE": "DATA CHANGED IN RECORD",
    "KEA": "ADDRESS CHANGE",
    "KEAN": "A NUMBER CHANGE",
    "KEB": "DATE OF BIRTH CHANGE",
    "KEN": "NAME CHANGE",
    "KF": "CASE PROFILE HOLD PLACED",
    "KF0": "EXECUTE PROFILE",
    "KG": "CASE PROFILE HOLD CLEARED",
    "KH": "PENDING LITIGATION HOLD PLACED",
    "KI": "LITIGATION HOLD CLEARED",
    "KJ": "OPTICAL RECORD CREATED",
    "KK": "PREVIOUS ACTION CANCELLED",
    "KL": "PREVIOUS ACTION CANCELLED - FEE TO BE RETURNED",
    "KM": "PAPER RECORD DESTROYED",
    "KN": "PAPER RECORD ARCHIVED",
    "KO": "PETITION SHIPPED TO DOS AFTER APPROVAL OR REAFFIRMATION",
    "KP": "PETITION SHIPPED BY DOS TO CONSULATE",
    "KQ": "PREVIOUS ACTION VOIDED",
    "KR0": "AAO CONVERSION RECORD",
    "KSB": "CLASS SB1 - PROCESSING COMPLETE",
    "LAA": "CARD REQUEST SENT TO ICPS PRINT SERVER",
    "LAB": "CARD ORDER CORRECTED OR VERIFIED AND RESENT TO ICF",
    "LBA": "CARD ORDER RECEIVED AT ICF",
    "LC": "CARD ORDER RETURNED TO ORDERING OFFICE FOR VERIFICATION/CORRECT.",
    "LDA": "CARD PRODUCED",
    "LDB": "CARD DESTROYED; DID NOT MEET SPECIFICATIONS",
    "LEA": "CARD MAILED TO APPLICANT",
    "LEB": "CARD MAILED TO AMC",
    "LEC": "CARD PERSONALLY GIVEN TO APPLICANT",
    "LFA": "CARD RETURNED AS UNDELIVERABLE",
    "LFB": "CARD DESTROYED SINCE UNDELIVERABLE",
    "LFC": "CARD NOT DELIVERED AND NOT RETURNED",
    "LGA": "CARD RETURNED WITH CORRESPONDENCE",
    "LGB": "CARD DESTROYED SINCE RETURNED WITH CORRESPONDENCE",
    "LIC": "FINGERPRINT NOT READABLE",
    "LLBB": "I-89 RECEIVED NO COMPANION ELECTRONIC RECORD",
    "LLBC": "ELECTRONIC RECORD RECEIVED, NO COMPANION I-89",
    "LLBD": "VISA OR ADJ. RECORD RECEIVED, NO COMPANION I-89",
    "LLBE": "ICF DOES NOT PROCESS SB1 VISAS",
    "LLGA": "APPLICANT SIGNATURE DOES NOT MEET SPECIFICATIONS",
    "LLGB": "NO APPLICANT SIGNATURE ON I-89 AND NOT SHOWN AS WAIVED",
    "LLH": "PHOTOGRAPHS DO NOT MEET SPECIFICATIONS",
    "LLIA": "FINGERPRINT NOT READABLE",
    "LLIB": "FINGERPRINT MISSING AND NOT UNDER AGE OR WAIVED",
    "LLJA": "I-89 DAMAGED AND CANNOT BE USED",
    "LLJB": "PHOTOGRAPHS DAMAGED AND CANNOT BE USED",
    "LLKA": "CARD ORDER DATA INCONSISTENT WITH OTHER RECORDS",
    "LLKB": "OTHER RECORDS INDICATE APPLICANT HAS NATURALIZED",
    "LLKC": "A# PREVIOUSLY USED ON CARD ISSUED TO SOMEONE ELSE",
    "LLKD": "DISCREPANCY IN A# ON MATERIAL SUBMITTED",
    "LLKE": "DOB AND ADJ/ADMISSION DATE INCOMPATIBLE",
    "LLKF": "WRONG SIDE OF I-89 COMPLETED FOR THIS TRANSACTION",
    "LLKG": "NECESSARY DATA FOR THIS TYPE CARD ORDER MISSING OR ILLEGIBLE",
    "LLKH": "SUBJECTS CONDITIONAL PERIOD HAS EXPIRED",
    "LLKI": "REMOVAL OF CONDITIONAL STATUS APPEARS PREMATURE",
    "LLKJ": "ADMISSION CODE AND DATE OF ADMISSION INCOMPATIBLE",
    "LLKK": "DATA AND PHOTO CLEARLY INCOMPATIBLE",
    "LLLA": "VERIFYING SIGNATURE AND DATA MISSING, INCOMPLETE OR ILLEGIBLE",
    "LLLB": "ADMISSION DATA OR ADMISSION STAMP ILLEGIBLE ON VISA",
    "LLLC": "WRONG ISSUE OF CARD RETURNED WITH CARD ORDER",
    "LLM": "CARD ORDER APPEARS TO BE DUPLICATE",
    "LM": "DUPLICATE CARD ORDER",
    "LN": "FINGERPRINT DETERMINED TO BE BEST AVAILABLE",
    "LO": "CARD NOT PRODUCED SINCE CONDITIONAL STATUS EXPIRES WITHIN 60 DAYS",
    "LPA": "CARD ORDER WITHDRAWN",
    "LSP": "STOP CARD PRODUCTION",
    "M01": "NO PHOTO AVAILABLE",
    "M01F": "FINGERPRINT NOT WAIVED",
    "M01S": "SIGNATURE NOT WAIVED",
    "M02": "IMPROPER PHOTO",
    "M02S": "IMPROPER SIGNATURE",
    "M03": "PHOTO MISMATCH",
    "M03S": "SIGNATURE MISMATCH",
    "M04": "DATA MISMATCH",
    "M05": "BAD SCAN",
    "M06": "BAD CARD PRINT",
    "M07": "BAD DIECUT",
    "M08": "BAD LAMINATION",
    "M09": "BAD STOCK",
    "M10": "BOOK NUMBER MISMATCH",
    "M11": "MRZ NOT READABLE",
    "M201": "SCAN SUCCESSFUL",
    "M202": "SENT TO PRINTER",
    "M203": "UNDER SUPERVISOR REVIEW",
    "M207": "GOOD CARD QUALITY",
    "MA": "CARD COMPLETED",
    "MA0": "EAD SIGNATURE CARD PRINTED",
    "MA70": "BIOMETRICS RECEIVED FROM ASC",
    "MA80": "CARD REQUEST SENT TO ICPS",
    "MA90": "BAD/MISSING DATA IN CARD REQUEST(E.G., ADDRESS MISSING)",
    "MA91": "BAD/MISSING DATA FILE DURING CARD PRODUCTION",
    "MA92": "BAD/MISSING DATA IN STREAM",
    "MA93": "DUPLICATE RECEIPT NUMBER IN SAME PRODREQ.DAT",
    "MA94": "DUPLICATE APPLICATION ID RECEIVED WHILE CARD IN PRODUCTION",
    "MA95": "UNKNOWN RETURN ADDRESS",
    "MA97": "MISSING CARD MEDIA OR CARD FORMAT IN PRODREQ.DAT",
    "MA98": "RESERVED FOR FUTURE ICPS USE",
    "MA99": "RESERVED FOR FUTURE ICPS USE",
    "MBA": "REENTRY PERMIT PRODUCED",
    "MBB": "REFUGEE TRAVEL DOCUMENT PRODUCED",
    "MBC": "ADVANCE PAROLE DOCUMENT PRODUCED",
    "MCA": "NATURALIZATION CERTIFICATE PRODUCED",
    "MCB": "CITIZENSHIP CERTIFICATE PRODUCED",
    "MCC": "REPATRIATION CERTIFICATE PRODUCED",
    "MCD": "DECLARATION OF INTENT PRODUCED",
    "MCE": "SPECIAL CERTIFICATE OF NATURALIZATION PRODUCED",
    "MDA": "DOCUMENT PENDING DESTRUCTION",
    "MDB": "DOCUMENT DESTROYED, DID NOT MEET SPECIFICATIONS",
    "MEA": "DOCUMENT MAILED TO APPLICANT",
    "MEBA": "DOCUMENT MAILED TO DOMESTIC OFFICE FOR DISTRIBUTION",
    "MEBB": "DOCUMENT MAILED TO OVERSEAS OFFICE OR DOS FOR DISTRIBUTION",
    "MEC": "DOCUMENT PERSONALLY GIVEN TO APPLICANT",
    "MFA": "DOCUMENT RETURNED AS UNDELIVERABLE",
    "MFB": "DOCUMENT DESTROYED SINCE UNDELIVERABLE",
    "MFC": "DOCUMENT FILED SINCE UNDELIVERABLE",
    "MGA": "RE-ENTRY PERMIT VOIDED",
    "MGB": "REFUGEE TRAVEL DOCUMENT VOIDED",
    "MI": "INTERIM 13(d) EAD CARD PRODUCED OFF-SYSTEM",
    "MO": "EAD NOT PRODUCED SINCE ADJUSTMENT GRANTED",
    "NA": "OSC ORDERED",
    "NB": "OSC PRODUCED",
    "NC": "OSC SERVED",
    "ND": "OSC RETURNED AS UNDELIVERABLE",
    "NE": "OSC CANCELLED",
    "NF": "BOND POSTED",
    "NG": "BOND CANCELLED",
    "NHA": "ENGLISH PROFICIENCY DEMONSTRATED FOR NATZ. PURPOSES",
    "NHB": "CIVICS PROFICIENCY DEMONSTRATED FOR NATZ. PURPOSES",
    "NHC": "ENGLISH AND CIVICS PROFICIENCY BOTH DEMONSTRATED FOR NATZ. PURP.",
    "NI": "INTENTION TO TERMINATE STATUS NOTICE ORDERED",
    "NJA": "STATUS TERMINATION NOTICE ORDERED",
    "NJB": "STATUS TERMINATION CERTIFICATION NOTICE ORDERED",
    "NK": "AUTOMATIC INVITATION TO FILE FOR NEXT STEP OF STAGED BENEFIT NO",
    "OA": "APPEAL SUSTAINED",
    "OB": "APPEAL DISMISSED",
    "OC": "CASE REMANDED",
    "OD": "EXTENSION FOR BRIEF GRANTED",
    "OD0": "DECISION AFFIRMED ON APPEAL/CERT.",
    "ODD0": "DECISION REVERSED ON APPEAL/CERT.",
    "OE": "EXTENSION FOR BRIEF DENIED",
    "OF": "APPEAL TERMINATED",
    "OG": "APPEAL WITHDRAWN",
    "OH": "CERTIFIED DECISION AFFIRMED",
    "OHA": "CERTIFIED APPROVAL AFFIRMED",
    "OHB": "CERTIFIED DENIAL AFFIRMED",
    "OI": "CERTIFIED DECISION REVERSED",
    "OIA": "CERTIFIED APPROVAL REVERSED/CASE DENIED",
    "OIB": "CERTIFIED DENIAL REVERSED/CASE APPROVED",
    "PA": "CASE MARKED AS PREMIUM PROCESSING",
    "PAA": "PREMIUM PROCESSING CLOCK STARTED",
    "PAAM": "PREMIUM PROCESSING CLOCK STARTED MANUALLY",
    "PAB": "PREMIUM PROCESSING CLOCK STOPPED",
    "PABM": "PREMIUM PROCESSING CLOCK STOPPED MANUALLY",
    "PAC": "PREMIUM PROCESSING CLOCK DATE CHANGED",
    "PB": "PRE-CERTIFICATION MARKED",
    "PC": "PRE-CERTIFICATION UNMARKED",
    "QAA": "FBI NAME CHECK RESULT - NO RECORD (NR)",
    "QAB": "FBI NAME CHECK RESULT - PENDING (IP)",
    "QAC": "FBI NAME CHECK RESULT - ERROR (E)",
    "QAD": "FBI NAME CHECK RESULT - DUPLICATE (D)",
    "QAE": "FBI NAME CHECK RESULT - POSITIVE RESPONSE (PR)",
    "QAF": "FBI NAME CHECK RESULT - RESUBMIT NAME CHECK REQUEST (RS)",
    "RH": "APPLICANT IS CODE H",
    "RO": "APPLICANT IS CODE O",
    "TA": "PRE-ADJUDICATED - UNDER REVIEW",
    "WK": "APPEAL FILED",
    "WL": "I-698 APPEAL FILED"
}

export const EventCodes = {
    "IMAG": "BIOMETRICS APPOINTMENT NOTICE SENT",
    "SA": "CASE APPROVAL DECISION WAS RENDERED",
    "H008": "CASE APPROVED",
    ...NiemEventCodes,
}